import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * 保留 locationId snowflake 精度。
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:fromLocationId|toLocationId|locationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/**
 * PD-ETA-01：後端估時；FE 禁止直打 Routes／Distance provider。
 */
export const journeyRoutingApi = {
  estimate: (journeyId, body) => travelClient.post(
    travelEndpoints.journeyRoutingEstimate(journeyId),
    body,
    snowflakeJson,
  ),
};
